export const storeAnalytics = (proxyCode) => {
  const orderLabels = {
    IPv4: "order",
    IPv6: "order_ipv6",
    MOBILE: "order_mobile"
  };
  
  const orderLabel = orderLabels[proxyCode] || "order";
  
  const isProduction = window.location.hostname !== "localhost";
  
  if (!isProduction) return;

  // google
  if (
    window.location.hostname !== "localhost" &&
    typeof window.gtag !== "undefined"
  ) {
    // eslint-disable-next-line no-undef
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "Click", {
        event_category: "Pay_Button",
        event_label: orderLabel
      });
    }
  }
  
  // yandex
  if (typeof window.ym !== "undefined") {
    ym(87392270, "reachGoal", orderLabel);
  }
};
